export enum OpenModalActions {
  Edit = "Edit",
  Add = "Add",
  View = "View",
}
